import { useContext } from "react";

import { PaymentContext } from "utils/context/payment";

export const usePaymentContext = () => useContext(PaymentContext);
